import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LocalKeys } from '~/app/lib/local-keys'
import { Tenant } from './auth.type'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  expiry: string | null
  tempToken: string | null
  tenants: Tenant[]
  selectedTenant: Tenant | null
  setAuth: (accessToken?: string, refreshToken?: string, expiry?: string) => void
  setTempAuth: (tempToken: string, tenants: Tenant[]) => void
  setSelectedTenant: (tenant: Tenant) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      expiry: null,
      tempToken: null,
      tenants: [],
      selectedTenant: null,
      setAuth: (accessToken, refreshToken, expiry) =>
        set({ accessToken, refreshToken, expiry, tempToken: null }),
      setTempAuth: (tempToken, tenants) => set({ tempToken, tenants }),
      setSelectedTenant: (tenant) => set({ selectedTenant: tenant }),
      clearAuth: () =>
        set({
          accessToken: null,
          refreshToken: null,
          expiry: null,
          tempToken: null,
          tenants: [],
          selectedTenant: null,
        }),
    }),
    {
      name: LocalKeys.AUTH_TOKEN,
    }
  )
)
